export class JobSnapshotDetails {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "pointInTime",
            "baseName": "pointInTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "expirationTime",
            "baseName": "expirationTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "backupRetention",
            "baseName": "backupRetention",
            "type": "number",
            "format": ""
        },
        {
            "name": "accessDeniedItemsCount",
            "baseName": "accessDeniedItemsCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "accessDeniedItemsBytes",
            "baseName": "accessDeniedItemsBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "userFilteredObjectsCount",
            "baseName": "userFilteredObjectsCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "userFilteredObjectsBytes",
            "baseName": "userFilteredObjectsBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "saasWorkloads",
            "baseName": "saasWorkloads",
            "type": "Array<SaasWorkloadBackupStats>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobSnapshotDetails.attributeTypeMap;
    }
    constructor() {
    }
}
